//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';
import { useSelector } from 'react-redux';

import { Modal } from '@components/molecules/modal/Modal';
import { useBoundActionCreators } from '@hooks/useCuralateStore';
import makeAngularReactController from '@react-bridge/angular-react-widget';
import { streamDeletionActions } from '@streams/actions/streamDeletionActions';
import * as streamsDrawerActions from '@streams-drawer/actions/streams-drawer-actions';

const StreamDeleteConfirmationModal = () => {
  const { isDeletingStream } = useSelector(
    (state) => state.streams.streamDeletion,
  );

  const { closeStreamDeleteConfirmationModal } =
    useBoundActionCreators(streamsDrawerActions);
  const { deleteStream } = useBoundActionCreators(streamDeletionActions);

  const primaryButtonInfo = {
    buttonContent: 'Yes, remove the Stream',
    onClick: () => {
      deleteStream();
    },
    isDisabled: isDeletingStream,
  };

  return (
    <Modal
      closeModal={closeStreamDeleteConfirmationModal}
      contents='Deleting a stream will remove it from your list of streams.'
      isModalOpen={true}
      primaryButtonInfo={primaryButtonInfo}
      title='Are you sure?'
    />
  );
};

export default StreamDeleteConfirmationModal;

angular.module('curalate').component('streamDeleteConfirmationModal', {
  controller: makeAngularReactController(<StreamDeleteConfirmationModal />),
});
